var exports = {
  "k": "xfb577c5e--dbb3d3--container",
};

module.exports = exports;
